export default {
    carregando: false,
    items: [],
    selecionado: {
        titulo: '',
        corpo: [],
        url: '',
        metodo: ''
    }
}